/** Supply order line item / category labels (aligned with mobile). */

export function getSupplyItemDisplayTitle(item, displayLang = "EN") {
  if (!item) return "Unknown Supply";
  if (displayLang === "ES") {
    const es = String(item.spanish_title ?? "").trim();
    if (es) return es;
    return String(item.title ?? "").trim() || "Unknown Supply";
  }
  const en = String(item.title ?? "").trim();
  if (en) return en;
  return String(item.spanish_title ?? "").trim() || "Unknown Supply";
}

export function getSupplyCategoryDisplayTitle(
  item,
  displayLang = "EN",
  catalogFallback = {}
) {
  const catalogTitle = catalogFallback?.title ?? catalogFallback?.categoryTitle;
  const catalogSpanishTitle =
    catalogFallback?.spanish_title ?? catalogFallback?.category_spanish_title;

  if (displayLang === "ES") {
    const stored = String(item?.category_spanish_title ?? "").trim();
    if (stored) return stored;
    if (String(catalogSpanishTitle ?? "").trim()) return String(catalogSpanishTitle).trim();
    const enStored = String(item?.categoryTitle ?? "").trim();
    if (enStored) return enStored;
    return String(catalogTitle ?? "").trim() || "Uncategorized";
  }

  const stored = String(item?.categoryTitle ?? "").trim();
  if (stored) return stored;
  if (String(catalogTitle ?? "").trim()) return String(catalogTitle).trim();
  const esStored = String(item?.category_spanish_title ?? "").trim();
  if (esStored) return esStored;
  return String(catalogSpanishTitle ?? "").trim() || "Uncategorized";
}

/**
 * Merge catalog snapshots onto line items when historical fields are missing.
 */
export function snapshotSupplyOrderItem(item = {}, catalogItem = {}, parentCategory = {}) {
  if (!item || typeof item !== "object") return item;
  return {
    ...item,
    title: item.title ?? catalogItem?.title ?? "",
    spanish_title: item.spanish_title ?? catalogItem?.spanish_title ?? "",
    parentCategoryId:
      item.parentCategoryId ?? catalogItem?.parentCategoryId ?? parentCategory?.id ?? "",
    categoryTitle: item.categoryTitle ?? parentCategory?.title ?? "",
    category_spanish_title:
      item.category_spanish_title ?? parentCategory?.spanish_title ?? "",
    qty: item.qty ?? catalogItem?.qty ?? 0,
  };
}

export function enrichSupplyItemsWithCatalogSnapshots(supplyItems = [], categoriesById = {}) {
  if (!Array.isArray(supplyItems)) return [];
  return supplyItems.map((item) => {
    const catalogItem = categoriesById[item?.id] || categoriesById[item?.supplyId] || {};
    const parentCategory =
      categoriesById[item?.parentCategoryId] ||
      (item?.parentCategoryId ? { id: item.parentCategoryId } : {});
    return snapshotSupplyOrderItem(item, catalogItem, parentCategory);
  });
}
